import { z } from "zod";

export const ZUser = z.object({
  uuid: z.string().uuid(),
  email: z.string().email(),
  name: z.string(),
  profile_photo_url: z.string().nullable(),
  created_at: z.string(),
});

export const ZTask = z.object({
  uuid: z.string().uuid(),
  user_uuid: z.string().uuid(),
  raw_input: z.string(),
  title: z.string().nullable(),
  description: z.string().nullable(),
  urgency: z.enum(["low", "medium", "high"]).nullable(),
  importance: z.enum(["low", "medium", "high"]).nullable(),
  ai_enriched: z.boolean(),
  ai_enriched_at: z.string().nullable(),
  status: z.enum(["backlog", "today", "done", "archived"]),
  source: z.enum(["manual", "slack", "recurring", "agent"]),
  source_slack_channel: z.string().nullable(),
  source_agent: z
    .object({
      client_id: z.string(),
      client_name: z.string().nullable().optional(),
      agent_session_id: z.string().nullable().optional(),
    })
    .nullable()
    .optional()
    .transform((v) => v ?? null),
  source_slack_message_ts: z.string().nullable(),
  source_slack_permalink: z.string().nullable(),
  recurring_def_id: z.string().uuid().nullable(),
  due_date: z.string().nullable(),
  instance_date: z.string().nullable(),
  sort_order: z.number(),
  today_sort_order: z.number(),
  moved_to_today_at: z.string().nullable(),
  completed_at: z.string().nullable(),
  archived_at: z.string().nullable(),
  created_at: z.string(),
  updated_at: z.string(),
  url: z.string().nullable(),
  deleted_at: z.string().nullable(),
  deleted_by: z.string().uuid().nullable(),
  tag_id: z.string().uuid().nullable(),
  lead_time: z.number().nullable(),
  urgency_escalated_at: z.string().nullable(),
  last_nudged_at: z.string().nullable(),
  snooze_until: z.string().nullable(),
});

export const ZTaskDependency = z.object({
  uuid: z.string().uuid(),
  user_uuid: z.string().uuid(),
  prerequisite_uuid: z.string().uuid(),
  dependent_uuid: z.string().uuid(),
  created_at: z.string(),
  updated_at: z.string(),
  deleted_at: z.string().nullable(),
});

export const ZTag = z.object({
  id: z.string().uuid(),
  user_uuid: z.string().uuid(),
  name: z.string(),
  color: z.string(),
  created_at: z.string(),
  updated_at: z.string(),
});

export const ZTagShare = z.object({
  id: z.string().uuid(),
  tag_id: z.string().uuid(),
  shared_with_uuid: z.string().uuid(),
  shared_by_uuid: z.string().uuid(),
  created_at: z.string(),
});

export function parseUnknownError(error: unknown): string {
  if (error instanceof Error) return error.message;
  if (typeof error === "string") return error;
  return "An unknown error occurred";
}
